import { render } from "./replace.vue?vue&type=template&id=6a93e151"
import script from "./replace.vue?vue&type=script&lang=js"
export * from "./replace.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/replace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a93e151"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a93e151', __exports__)) {
    api.reload('6a93e151', __exports__)
  }
  
  module.hot.accept("./replace.vue?vue&type=template&id=6a93e151", () => {
    api.rerender('6a93e151', render)
  })

}


export default __exports__